import {
  FeatureWrap,
  LanguagePicker,
  Modal,
  ModalTabs,
  PDFRenderer,
} from "components";
import { useKEKOffer, useKEKOfferParticipant } from "hooks/data/use-offers";
import { useMatch, useSearch } from "react-location";

import { LocationGenerics } from "router/location";
import config from "config";
import { useFormik } from "formik";
import { useState } from "react";

const tabs = [
  {
    name: "Closing Note",
    href: "CLOSING_NOTE",
  },
  {
    name: "NIC Schedule",
    href: "NIC_SCHEDULE",
    country: "ghana",
  },
];

export default function ViewNoteContainer({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (val: boolean) => void;
}) {
  const form = useFormik({
    initialValues: {
      lang: "en",
    },
    onSubmit(values, formikHelpers) {},
  });
  const searchParams = useSearch<LocationGenerics>();
  const { params } = useMatch<LocationGenerics>();
  const [orderStatus, setOrderStatus] = useState("CLOSING_NOTE");
  const { loading, offer } = useKEKOffer({
    offer_id: params?.offer || "",
  });

  const { loading: fetchingParticipant, participant } = useKEKOfferParticipant({
    participantId: searchParams?.id || "",
  });

  const url =
    orderStatus === "NIC_SCHEDULE"
      ? `${config.asset.uri}nic_form/${btoa(
          JSON.stringify({
            offer_id: params?.offer || "",
            reinsurer_id: participant?.reinsurer.reinsurer_id,
            lang: form.values.lang,
          })
        )}`
      : `${config.asset.uri}generate_closing_slip/${btoa(
          JSON.stringify({
            offer_id: params?.offer || "",
            reinsurer_id: participant?.reinsurer.reinsurer_id,
            period_from: offer?.offer_detail?.period_of_insurance_from,
            period_to: offer?.offer_detail?.period_of_insurance_to,
            lang: form.values.lang,
          })
        )}`;

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      loading={loading || fetchingParticipant}
      hideActions
      size="6xl"
      title="Closing Note and NIC Schedule"
      description="View Closing Note and NIC Schedule"
    >
      <ModalTabs
        tabs={tabs}
        orderStatus={orderStatus}
        setOrderStatus={setOrderStatus}
      />
      <div className="p-3">
        <FeatureWrap domains={["Visal"]}>
          <div className="mb-3">
            <LanguagePicker id={"lang"} labelHidden {...form} />
          </div>
        </FeatureWrap>
        <PDFRenderer url={url} />
      </div>
    </Modal>
  );
}
